import moment from "moment-msdate";

import IFormulaBase from "./formulaBase";
import { makeDisplayMvtsLink, setApiURL } from "@taskpane/utils";
import { standardDateFormat } from "@taskpane/types";
import { Endpoints } from "../core/endpoints";

export interface TPBalanceFormulaData {
  companyName: string;
  fiscalYear: string;
  subledgerAccountCode: string;
  fromDate: string;
  toDate: string;
  thirdPartyCode: string;
  thirdPartyCurrency: string;
  withOpeningBalance: string;
  withMovements: string;
  originalCurrency: string;
  debits: string;
  credits: string;
  payed: string;
  billed: string;
}

export default class TPBalanceFormula implements IFormulaBase {
  constructor(private token: string | null) { }
  private name = "PMCLIBalance";
  formulaData: TPBalanceFormulaData;

  generate() {
    const data = this.formulaData;
    return `#${this.name}/${data.companyName}/${data.fiscalYear}/${data.thirdPartyCode}/${data.thirdPartyCurrency}/{${data.fromDate}}/{${data.toDate}}/${data.subledgerAccountCode}/${data.withOpeningBalance}/${data.withMovements}/${data.originalCurrency}/${data.debits}/${data.credits}`;
  }

  async getAmount(): Promise<number | string> {
    const data = this.formulaData;
    return await fetch(setApiURL(Endpoints.getThirdPartyBalance(data.companyName, data.fiscalYear)) + "?" + new URLSearchParams({
      subledger_account_code: data.subledgerAccountCode,
      third_party_code: data.thirdPartyCode,
      third_party_currency: data.thirdPartyCurrency,
      from_date: data.fromDate,
      to_date: data.toDate,
      with_opening_balance: data.withOpeningBalance ? "true" : "false",
      with_movements: data.withMovements ? "true" : "false",
      with_original_currency: data.originalCurrency ? "true" : "false",
      with_debit: data.debits ? "true" : "false",
      with_credit: data.credits ? "true" : "false",
      with_paid: data.payed ? "true" : "false",
      with_invoiced: data.billed ? "true" : "false",
    }).toString(), { method: 'GET', headers: { 'X-Apikey': this.token } }).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      };
      return response.json();
    });
  }

  parse(value: string): IFormulaBase {
    if (!isNaN(<any>value)) return null;
    if (!value) return null;
    if (!value.startsWith("#" + this.name)) return null;
    const formulaInst = new TPBalanceFormula(this.token);
    let tvalue = value;
    let match = tvalue.match(/\{[0-9,/-]*\}/);

    while (match && match.length > 0) {
      const concatValue = match[0]
        .substring(1, match[0].length - 1);

      tvalue =
        tvalue.substring(0, tvalue.indexOf(match[0])) +
        (!isNaN(<any>concatValue) ? concatValue :
          concatValue.replace(/\//g, "dateSep")
            .replace(",", ".")) +
        tvalue.substring(tvalue.indexOf(match[0]) + match[0].length);
      match = tvalue.match(/\{[0-9,/-]*\}/);
    }

    const values = tvalue.split("/");
    const dateFromString = !isNaN(<any>values[5]) ? values[5] : values[5].replace(/dateSep/g, "/");
    const dateToString = !isNaN(<any>values[6]) ? values[6] : values[6].replace(/dateSep/g, "/");

    formulaInst.formulaData = {
      companyName: values[1],
      fiscalYear: values[2],
      thirdPartyCode: values[3],
      thirdPartyCurrency: values[4],
      fromDate: !isNaN(<any>dateFromString) ? moment.fromOADate(dateFromString).format(standardDateFormat) : dateFromString,
      toDate: !isNaN(<any>dateToString) ? moment.fromOADate(dateToString).format(standardDateFormat) : dateToString,
      subledgerAccountCode: values[7],
      withOpeningBalance: values[8].toLowerCase().trim(),
      withMovements: values[9].toLowerCase().trim(),
      originalCurrency: values[10].toLowerCase().trim(),
      debits: values.length > 11 ? values[11].toLowerCase().trim() : "true",
      credits: values.length > 12 ? values[12].toLowerCase().trim() : "true",
      payed: values.length > 13 ? values[13].toLowerCase().trim() : "true",
      billed: values.length > 14 ? values[14].toLowerCase().trim() : "true",
    };
    return formulaInst;
  }


  getDisplayMvtsLink(): string {
    return "";
    /*
    return makeDisplayMvtsLink(this.formulaData.companyId,
      this.formulaData.fromDate,
      this.formulaData.toDate,
      this.formulaData.subledgerClientText,
      this.formulaData.currency,
      this.formulaData.withZeroAccounts === 'true',
      this.formulaData.withOpeningBalance === 'true',
      this.formulaData.withMvts === 'true',
      true,
      this.formulaData.debits === 'true',
      this.formulaData.credits === 'true');
    */
  }

  async getMvts() {
    const data = this.formulaData;
    const result = await fetch(setApiURL(Endpoints.getThirdPartyBalanceMvts(data.companyName, data.fiscalYear)) + "?" + new URLSearchParams({
      third_party_code: data.thirdPartyCode,
      third_party_currency: data.thirdPartyCurrency,
      from_date: data.fromDate,
      to_date: data.toDate,
    }).toString(), { method: 'GET', headers: { 'X-Apikey': this.token } }).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      };
      return response.json();
    });
    return result;
  }
}
